import { fromNanoToUnit, selectBonuses } from "@/entities/bonus"
import { useAppSelector } from "@/shared/lib/redux"
import { selectAggregates } from "../../model"
import { useMemo } from "react"
import { ChartBlock } from "@/shared/ui/chart-block"

export const SumTransactions = () => {
    const bonuses = useAppSelector(selectBonuses)
    const aggregates = useAppSelector(selectAggregates)

    const data = useMemo(() => {
        const parsed = bonuses
            .map((bonus) => ({
                bonus: bonus,
                data:  fromNanoToUnit(aggregates.bonuses[bonus.id]?.sum_amount_nano ?? 0)
            }))
            .filter((exists) => exists.data ?? 0)
        const labels = parsed.map(obj => obj.bonus.name)
        const data = parsed.map(obj => obj.data)
        return {
            labels,
            datasets: [{
                data
            }]
        }
            
    }, [bonuses, aggregates])

    return (
        <ChartBlock chartClass="min-h-[350px] h-full" type="doughnut" title="Сумма транзакций по бонусам" data={data}/>
    )
}